import { useRef } from "react";
import { Button, Col, Form, Row, Spinner } from "react-bootstrap";
import styled from "styled-components";

interface FileUploaderProps {
  onClear: () => void;
  onUpload?: () => void;
  onChange: (file: File) => void;
  onBlur?: (e: any) => void;
  disableButtons?: boolean;
  placeholder?: string;
  loading?: boolean;
}

const UploadButton = styled(Button)`
  border-radius: 0;
`;

const ClearButton = styled(Button)`
  border-radius: 0 0.25rem 0.25rem 0;
`;

const Input = styled(Form.Control)`
  border-radius: 0.25rem 0 0 0.25rem;
  &:focus {
    border-color: none;
    box-shadow: none;
  }
`;

const StyledSpinner = styled(Spinner)`
  height: 20px;
  width: 20px;
  --bs-spinner-border-width: 0.10em;
`;


const FileUploader = ({
  onClear,
  onUpload,
  onChange,
  onBlur,
  disableButtons,
  placeholder,
  loading
}: FileUploaderProps) => {
  const fileInputRef = useRef(null);

  const clear = () => {
    if (fileInputRef.current) {
      (fileInputRef.current as any).value = null;
    }
    onClear();
  };

  return (
    <>
      <Row className="pr-0 w-100">
        <Col className="d-flex">
          <Input
            placeholder={placeholder}
            onChange={(e: any) => onChange(e.target.files[0])}
            type="file"
            ref={fileInputRef}
            onBlur={onBlur}
          />
          {onUpload && (
            <UploadButton onClick={() => onUpload()} disabled={disableButtons || loading}>
              {
                loading  ? <StyledSpinner  animation="border"  /> : "Upload"
              
              }
            </UploadButton>
          )}

          <ClearButton
            className="bg-danger border-danger"
            onClick={() => clear()}
            disabled={disableButtons || loading}
          >
            Clear
          </ClearButton>
        </Col>
      </Row>
    </>
  );
};

export default FileUploader;
